module.exports = __webpack_public_path__ + "static/numbers-1-5f645c54c1b3a165b67d3d3585be8fd4.png";